import { useEffect, useState } from "react";
import Top from "../components/templates/top";
import listText from "../utils/dictionaries/dictionary-black-lists";
import Image from "../../infraestructure/components/atoms/image";
import hexagonExclamation from "../assets/icons/hexagon-exclamation.svg";
import hiHand from "../assets/icons/ic_hi_hand_blue.svg";
import Title from "../components/atoms/title";
import Paragraph from "../components/atoms/paragraph";
import Button from "../components/atoms/button";
import ic_phone_white from "../assets/icons/ic_phone_white.svg";
import { useNavigate } from "react-router-dom";
import PersonalDataService from "../services/personalData.service";
import { DataINEuseCase } from "../../application/use-cases/dataINE.usecase";
import { store } from "../redux/store";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import Loader from "../components/atoms/loader";
import { useDispatch } from "react-redux";
import { changeIsClient } from "../redux/slices/dataReducer";

const BlackLists = () => {
  const [num, setNum] = useState(Number);
  const navigate = useNavigate();
  const getBlackLists = new PersonalDataService();
  const useCaseGetBlackLists = new DataINEuseCase(getBlackLists);
  const state = store.getState();
  const [modalShow, setModalShow] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();

  interface romanType {
    [key: number]: string;
  }

  const textPrimaryButton: romanType = {
    400.5: listText.text_15.mainText,
    400.6: listText.text_16.mainText,
    400.7: listText.text_16.mainText,
    400.8: listText.text_16.mainText,
    400.9: listText.text_18.mainText,
    400.10: listText.text_16.mainText,
  };

  const textParagraph: romanType = {
    400.5: listText.text_4.mainText,
    400.6: listText.text_6.mainText,
    400.7: listText.text_7.mainText,
    400.8: listText.text_8.mainText,
    400.9: listText.text_11.mainText,
    400.10: listText.text_14.mainText,
  };

  const textSubtitle: romanType = {
    400.5: listText.text_3.mainText,
    400.6: listText.text_5.mainText,
    400.7: listText.text_5.mainText,
    400.8: listText.text_5.mainText,
    400.9: listText.text_10.mainText,
    400.10: listText.text_13.mainText,
  };

  const textTitle: romanType = {
    400.5: listText.text_2.mainText,          //UIF
    400.6: listText.text_2.mainText,          //PEP
    400.7: listText.text_2.mainText,          //DetectArt 
    400.8: listText.text_2.mainText,          //Producto Vector 
    400.9: listText.text_9.mainText,          //Cliente CSB
    400.10: listText.text_12.mainText,        //CURP no válido
  };

  const next = async (value: string) => {
    if (value === "entendido") {
      [400.5].includes(num) ? navigate("/") :
        [400.9].includes(num) ? dispatch(changeIsClient({ isClient: true })) && navigate("/FiscalInformationClient")
          : window.open(`tel:8008003224`, "_self");
    } else {
      navigate("/");
    }
  }

  const functionProcessModal = () => {
    setShowLoader(false);
    setModalShow(false);
    navigate("/DataConfirmation")
  };

  const blackLists = async () => {
    setShowLoader(true);
    const response = await useCaseGetBlackLists.getBlackLists(state.client.clientPersist.uuid)
    if (response.error !== null) {
      setNum(Number(response.error.errorCode))
      if (response.status === 500 || response.error.errorCode === "404.n4_personal_data.1" ||
        response.status === 401) {
        setModalShow(true)
      } else {
        setShowLoader(false);
      }
    } else {
      setNum(response.status)
      navigate("/FiscalInformationClient")
    }
  };

  useEffect(() => {
    return () => {
      blackLists();
    }
  }, []);

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={""}
          displayProgressBar={"d-none"}
          displayLeftImageTitle={"d-none"}
          classTitleImage={"d-none"}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"d-none"}
          styleProgressBar={{}}
          classTitleAndImage={"d-none"}
          styleTitleAndImage={{}}
          valueProgressBar={""}
          onClickGoBackIcon={undefined}
          comeFrom={"/BlackLists"}
        />
        {
          showLoader ?
            <Loader />
            :
            <div className="p-3">
              <div className="text-center">
                <div className="mt-5 mb-4">
                  <Image
                    srcImage={[400.9].includes(num) ? hiHand : hexagonExclamation}
                    className={"bg-blue-light p-1"}
                    alt={""}
                    dataBsDismiss={""}
                    styleImg={{ borderRadius: "100%" }}
                    onClick={undefined}
                  ></Image>
                </div>

                <Title
                  text={textTitle[num]}
                  className={"fw-bold dark-blue-title"}
                  styleTitle={{ fontSize: "28px" }}
                />

                <div className="mb-4_3 mt-4_3">
                  <Paragraph
                    text={textSubtitle[num]}
                    className={"fs-5 lh-base dark-blue-title"}
                    styleParagraph={undefined}
                  />
                </div>

                <div className="mb-4_3">
                  <Paragraph
                    text={textParagraph[num]}
                    className={"fs-6 lh-base text-start dark-blue-title"}
                    styleParagraph={undefined}
                  />
                </div>
              </div>
            </div>
        }
      </div>

      {showLoader || num === 500 ?
        <Loader />
        :
        <div className="footer--pin">
          <Button
            text={textPrimaryButton[num]}
            img={[400.5, 400.9].includes(num) ? "" : ic_phone_white}
            classNameImg={""}
            divClassName={""}
            buttonClassName="btn-bg-primary text-white w-100 place-content-center align-self-center"
            spinner={false}
            onClick={() => next("entendido")}
            disabled={false}
          />

          <Button
            text={listText.text_17.mainText}
            img={""}
            classNameImg={""}
            divClassName={`my-4 ${[400.6, 400.7, 400.8, 400.10].includes(num) ? "d-block" : "d-none"}`}
            buttonClassName={
              "toggle-btn-dark-blue bg-white btn-outline-btn-dark-blue w-100 fw-semibold place-content-center align-self-center align-items-center"
            }
            spinner={false}
            onClick={() => next("terminar")}
            disabled={false}
          />
        </div>
      }
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle="¡Ups lo sentimos!"
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: "Reintentar",
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              functionProcessModal();
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => functionProcessModal()}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default BlackLists;
